<div class="toggle-container">
  <mat-slide-toggle
    class="ptl-slide-toggle"
    [class.waiting-list-toggle]="waitingList"
    [class.small]="size === 'small'"
    [checked]="checked"
    [labelPosition]="labelPosition"
    [attr.aria-label]="ariaLabel"
    [disabled]="disabled"
    (change)="onToggle($event)"
    (blur)="onBlur()"
  >
    <ng-content></ng-content>
    @if (ariaLabel) {
      <span class="cdk-visually-hidden">{{ ariaLabel }}</span>
    }
  </mat-slide-toggle>
</div>
